<template>
	<div>
		SideMenuProducts<br/>
		Filter för färg, storlek?
	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";



export default {
	name: "SideMenuProducts",
	components: {},
	mixins: [],
	props: {

	},
	data() {
		return {

		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });


	},
	created() {

	}
};
</script>

<style scoped></style>